import { type MouseEventHandler } from 'react';
import { Grid , Theme } from '@mui/material';
import Image from 'components/medias/Image';
import { ardoizIconPurple, ardoizLogoGreyBlue } from 'assets/images/brand';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme: Theme) => ({
  container: {
    cursor: 'pointer',
    padding: 20,

    [theme.breakpoints.up('md')]: {
      width: 200,
    },

    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
  },
  subtitle: {
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
  titlesContainer: {
    padding: '5px 10px',
  },
}), { name: 'ArdoizBrand' });

type ArdoizBrandProps = {
  onClick: MouseEventHandler;
};

const ArdoizBrand = ({ onClick }: ArdoizBrandProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.container}
      onClick={onClick}
    >
      <Grid item>
        <Image alt="Icône Ardoiz" src={ardoizIconPurple} width={50} />
      </Grid>

      <Grid item className={classes.titlesContainer}>
        <Image alt="Ardoiz" src={ardoizLogoGreyBlue} width={80} />
        <br />
        <span className={classes.subtitle}>
          <FormattedMessage id="app.name" />
        </span>
      </Grid>
    </Grid>
  );
};
export default ArdoizBrand;
